<template>
  <CSidebar class="custom-text" :minimize="minimize" unfoldable :show="show" @update:show="(value) => $store.commit('set', ['sidebarShow', value])">
    <!-- Toggle Button (mobile only) -->
    <button class="btn btn-light d-lg-none border-0 mr-2" @click="$store.commit('toggleSidebarMobile')">
      <!-- Hamburger icon -->
      <svg v-if="!isSidebarOpen" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
      </svg>

      <!-- Close icon -->
      <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>

    <CSidebarBrand class="d-md-down-none bg-white" to="/">
      <CRow class="mb-1 mt-1 justify-content-center">
        <CCol md="12"><img class="py-2" src="@/assets/serova_logo_blue.png" alt="" style="width: 100%; border-radius: 21px 21px" /></CCol>
        <!-- <CCol md="6"></CCol> -->
      </CRow>
    </CSidebarBrand>
    <ul class="d-flex flex-column p-1 overflow-auto mb-5 bg-white text-poppins">
      <span v-for="item in sidebarMenu" :key="item.key">
        <li v-if="item._name === 'TSidebarNavItem'" :class="getIClass(item.to)">
          <div @click="goTo(item.to)" class="d-flex align-items-center p-2 rounded">
            <div class="d-flex align-items-center" style="width: 20px; height: 20px">
              <component :is="item.icon" :name="item.icon" :className="[item.stroke ? 'icon-menu-stroke' : '', item.fill ? 'icon-menu-fill' : '']" />
            </div>
            <div v-if="!minimize" class="ms-2 d-flex align-items-center ml-2">
              <span>{{ item.name }} </span>
            </div>
          </div>
        </li>
        <li v-else-if="item._name === 'TSidebarNavSeparator'">
          <div class="TSidebarNavSeparator"></div>
        </li>
        <li v-else-if="item._name === 'TSidebarNavDropdown'">
          <div @click="toggleDropdown(item)" :class="['d-flex align-items-center justify-content-between p-2 cursor-pointer', getDropClass(item)]">
            <div class="d-flex align-items-center">
              <div style="width: 20px; height: 20px">
                <component :is="item.icon" :name="item.icon" :className="[item.stroke ? 'icon-drop-stroke' : '', item.fill ? 'icon-drop-fill' : '']" />
              </div>
              <div class="ml-2" :class="dropText(item)" v-if="!minimize">
                {{ item.name }}
              </div>
            </div>
            <div class="flex align-items-start" style="width: 20px; height: 20px">
              <div v-if="dropActive[item.name]" class="mb-4">
                <ChevronDownIcon className="icon-size" containerClass="text-black" />
              </div>
              <ChevronRightIcon v-else class="" className="icon-size" containerClass="text-black" />
            </div>
          </div>
          <ul v-if="dropActive[item.name]" :class="['ps-4', getDropChild(item)]">
            <li v-for="child in item._children" :key="child.key" class="cursor-pointer">
              <div @click="goTo(child.to, item)" :class="[getAClass(child.to), child.new ? 'text-warning' : '']" class="d-flex align-items-center py-2 hover-bg-primary text-dark hover-text-white">
                <div :class="getLineClass(child.to)" style="width: 2px; height: 30px"></div>
                <span :class="[child.icon ? 'ml-2' : 'ml-2']" v-if="!minimize">
                  {{ child.name }}
                </span>
              </div>
            </li>
          </ul>
        </li>
      </span>
    </ul>

    <CSidebarFooter class="logout mt-auto">
      <CRow @click="$bvModal.show('modal-logout')">
        <CCol md="2"><CIcon name="cil-account-logout" /></CCol> <CCol md="10" align="left">Logout</CCol>
      </CRow>
    </CSidebarFooter>
    <!-- <CSidebarMinimizer class="c-d-md-down-none" @click.native="$store.commit('toggle', 'sidebarMinimize')" /> -->
  </CSidebar>
</template>

<script>
export default {
  name: "TheSidebar",
  data() {
    return {
      drop_active: {},
      dropActive: {},
      tabActive: null,
    };
  },
  watch: {
    role: function (newV, oldV) {
      if (newV != oldV) {
        this.$forceUpdate();
      }
    },
  },
  computed: {
    menu() {
      return [
        {
          _name: "TSidebarNavItem",
          name: this.lang["dashboard"],
          to: "/dashboard",
          icon: "DashboardIcon",
          lang: "id",
          stroke: true,
          fill: false,
          role: ["super", "admin_hrd", "super_user"],
        },
        {
          _name: "TSidebarNavDropdown",
          name: this.lang["data_master"],
          icon: "MasterIcon",
          lang: "id",
          role: ["super", "admin_hrd", "super_user"],
          stroke: true,
          fill: false,
          _children: [
            { _name: "TSidebarNavItem", name: this.lang["asuransi"], to: "/asuransi", role: ["super", "super_user"] },
            { _name: "TSidebarNavItem", name: this.lang["mitra"], to: "/masterMitra" },
            { _name: "TSidebarNavItem", name: this.lang["dok_administrasi_pelamar"], to: "/dokAdministrasi" },
            { _name: "TSidebarNavItem", name: this.lang["gaji"], to: "/gaji", role: ["super", "super_user"] },
            { _name: "TSidebarNavItem", name: this.lang["divisi"], to: "/divisi" },
            { _name: "TSidebarNavItem", name: this.lang["jabatan"], to: "/masterJabatan" },
            { _name: "TSidebarNavItem", name: this.lang["lembur"], to: "/overtime", role: ["super", "super_user"] },
            { _name: "TSidebarNavItem", name: this.lang["pelanggaran"], to: "/pelanggaran", role: ["super", "super_user"] },
            { _name: "TSidebarNavItem", name: this.lang["shift"], to: "/masterShift" },
            { _name: "TSidebarNavItem", name: this.lang["tahapan_seleksi_pelamar"], to: "/tahapanSeleksi" },
            { _name: "TSidebarNavItem", name: this.lang["user"], to: "/user" },
            { _name: "TSidebarNavItem", role: ["super", "admin_hrd"], name: this.lang["role"], to: "/role" },
            { _name: "TSidebarNavItem", name: this.lang["role_user"], to: "/roleUser" },
            { _name: "TSidebarNavItem", name: this.lang["tunjangan"], to: "/tunjangan", role: ["super", "super_user"] },
            { _name: "TSidebarNavItem", name: this.lang["tunjangan_tidak_tetap"], to: "/tunjanganTidakTetap", role: ["super", "super_user"] },
            { _name: "TSidebarNavItem", name: this.lang["potongan"], to: "/potongan", role: ["super", "super_user"] },
            { _name: "TSidebarNavItem", name: this.lang["periode_penggajian"], to: "/periodePenggajian" },
          ],
        },
        {
          _name: "TSidebarNavItem",
          name: this.lang["lowongan_pekerjaan"],
          to: "/lowonganKerja",
          icon: "JobIcon",
          lang: "id",
          fill: true,
          role: ["admin_rekrutment", "super", "admin_hrd", "super_user"],
        },
        {
          _name: "TSidebarNavDropdown",
          name: this.lang["pelamar_kerja"],
          icon: "PelamarIcon",
          lang: "id",
          fill: true,
          stroke: true,
          role: ["admin_rekrutment", "super", "admin_hrd", "super_user"],
          _children: [
            { _name: "TSidebarNavItem", name: this.lang["pelamar"], to: "/pelamarKerja" },
            { _name: "TSidebarNavItem", name: this.lang["kelengkapan_pelamar"], to: "/kelengkapanPelamar" },
          ],
        },
        {
          _name: "TSidebarNavItem",
          name: this.lang["tahap_seleksi_pelamar"],
          to: "/tahapSeleksiPelamar",
          icon: "TahapanIcon",
          lang: "id",
          stroke: true,
          fill: false,
          role: ["admin_rekrutment", "super", "admin_hrd", "super_user"],
        },
        {
          _name: "TSidebarNavDropdown",
          name: this.lang["karyawan"],
          icon: "KaryawanIcon",
          lang: "id",
          role: ["super", "admin_hrd", "super_user"],
          fill: true,
          _children: [
            { _name: "TSidebarNavItem", name: this.lang["karyawan"], to: "/karyawan" },
            { _name: "TSidebarNavItem", name: this.lang["perjanjian_kerja"], to: "/perjanjianKerja",role: ["super", "super_user"] },
            { _name: "TSidebarNavItem", name: this.lang["perintah_kerja"], to: "/kontrak", role: ["super", "super_user"] },
            { _name: "TSidebarNavItem", name: this.lang["mutasi"], to: "/mutasi",role: ["super", "super_user"] },
          ],
        },
        {
          _name: "TSidebarNavItem",
          name: this.lang["kecelakaan_kerja"],
          to: "/kecelakaanKerja",
          icon: "AccidentIcon",
          fill: true,
          lang: "id",
          role: ["super", "admin_hrd", "super_user"],
        },
        {
          _name: "TSidebarNavDropdown",
          name: this.lang["laporan"],
          icon: "ReportIcon",
          lang: "id",
          fill: true,
          role: ["super", "super_user"],
          _children: [
            { _name: "TSidebarNavItem", name: this.lang["proyeksi_gaji"], to: "/laporanGaji" },
            { _name: "TSidebarNavItem", name: this.lang["rekap_gaji"], to: "/rekapGaji" },
            { _name: "TSidebarNavItem", name: this.lang["total_potongan"], to: "/totalPotongan" },
            { _name: "TSidebarNavItem", name: this.lang["thr"], to: "/THR" },
            { _name: "TSidebarNavItem", name: this.lang["lembur"], to: "/lembur" },
          ],
        },
        {
          _name: "TSidebarNavDropdown",
          name: this.lang["absensi"],
          icon: "AnttedanceIcon",
          lang: "id",
          stroke: true,
          role: ["super", "admin_hrd", "super_user", "spv"],
          _children: [
            { _name: "TSidebarNavItem", name: this.lang["rekap_absensi"], to: "/rekapAbsensi" },
            { _name: "TSidebarNavItem", name: this.lang["pengajuan_cuti"], to: "/pengajuanCuti" },
            { _name: "TSidebarNavItem", name: this.lang["pengajuan_lembur"], to: "/pengajuanLembur" },
            { _name: "TSidebarNavItem", name: this.lang["perubahan_shift"], to: "/perubahanShift" },
          ],
        },
        // {
        //   _name: "TSidebarNavItem",
        //   name: this.lang["surat_konfirmasi"],
        //   to: "/suratKonfirmasi",
        //   icon: "ConfirmationIcon",
        //   fill: true,
        //   lang: "id",
        //   role: ["super", "admin_hrd", "super_user"],
        // },
        {
          _name: "TSidebarNavDropdown",
          name: this.lang["penilaian_karyawan"],
          icon: "AssesmentIcon",
          fill: true,
          lang: "id",
          role: ["super", "admin_hrd", "super_user"],
          _children: [
            { _name: "TSidebarNavItem", name: this.lang["penilaian_karyawan"], to: "/assesmentKaryawan" },
            { _name: "TSidebarNavItem", name: this.lang["surat_peringatan"], to: "/warning" },
          ],
        },
        {
          _name: "TSidebarNavItem",
          name: this.lang["jadwal"],
          to: "/jadwal",
          icon: "ScheduleIcon",
          lang: "id",
          fill: true,
          role: ["supervisor", "super", "admin_hrd", "spv", "super_user"],
        },
        {
          _name: "TSidebarNavItem",
          name: this.lang["performance_management"],
          to: "/perform",
          icon: "PerformanceIcon",
          lang: "id",
          fill: true,
          role: ["super", "super_user"],
        },
        {
          _name: "TSidebarNavDropdown",
          name: this.lang["sarana"],
          icon: "JobIcon",
          fill: true,
          lang: "id",
          role: ["super", "admin_hrd", "super_user"],
          _children: [
            { _name: "TSidebarNavItem", name: this.lang["birthday"], to: "/tools_bday" },
            { _name: "TSidebarNavItem", name: this.lang["warning"], to: "/tools_warning" },
            { _name: "TSidebarNavItem", name: this.lang["appreciation"], to: "/tools_appreciation" },
            { _name: "TSidebarNavItem", name: this.lang["announcement"], to: "/announcement" },
            { _name: "TSidebarNavItem", name: this.lang["lateFines"], to: "/late_fines" },
            // { _name: "TSidebarNavItem", name: this.lang["tax"], to: "/tax" },
          ],
        },
        {
          _name: "TSidebarNavSeparator",
        },
        {
          _name: "TSidebarNavItem",
          name: this.lang["import_employee_data"],
          to: "/import_data",
          icon: "ImportIcon",
          lang: "id",
          fill: true,
          role: ["super", "admin_hrd", "super_user"],
        },
        {
          _name: "TSidebarNavItem",
          name: this.lang["video_tutorial_module"],
          to: "/tutorial",
          icon: "TutorialIcon",
          lang: "id",
          fill: true,
          role: ["supervisor", "super", "admin_hrd", "spv", "super_user"],
        },

        {
          _name: "CSidebarNavDivider",
          _class: "m-2",
        },
      ];
    },
    show() {
      return this.$store.state.sidebarShow;
    },
    lang() {
      return this.$store.state.sidebar;
    },
    akses() {
      return this.$store.state.all_akses ? this.$store.state.all_akses : [];
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
    role() {
      return this.$store.state.role_aktif ? this.$store.state.role_aktif.kodeRole : null;
    },
    filtered_menu() {
      return this.menu.filter((item) => {
        if (item._children) {
          item._children = item._children.filter((i) => {
            return !i.role || i.role.includes(this.role);
          });
        }
        return !item.role || item.role.includes(this.role);
      });
    },
    sidebarMenu() {
      return this.filtered_menu.map((item) => {
        if (item._name == "TSidebarNavDropdown") {
          this.drop_active[item.name] = false;
          if (item._children) {
            item._children.map((ele) => {
              if (ele._name == "TSidebarNavDropdown") {
                this.drop_active[ele.name] = false;
              }
              return item;
            });
          }
        }
        return item;
      });
    },
  },
  methods: {
    shown(x) {
      for (let y in this.drop_active) {
        if (y == x.name) {
          this.drop_active[y] = !this.drop_active[y];
        } else {
          this.drop_active[y] = false;
        }
      }
      this.$forceUpdate();
    },
    signout() {
      this.$store.commit("logout");
      this.$router.push("/login");
    },
    // goTo(e, to) {
    //   e.preventDefault();
    //   this.$router.push(to);
    // },
    toggleDropdown(item) {
      const isCurrentlyActive = this.dropActive[item.name];
      Object.keys(this.dropActive).forEach((key) => {
        this.dropActive[key] = false;
      });
      this.dropActive[item.name] = !isCurrentlyActive;
      this.$forceUpdate();
    },
    goTo(to, parentItem) {
      // Check if the clicked item is a dropdown
      if (parentItem && !this.dropActive[parentItem.name]) {
        this.dropActive[parentItem.name] = true;
      }

      if (!parentItem) {
        Object.keys(this.dropActive).forEach((key) => {
          this.dropActive[key] = false;
        });
      }

      this.tabActive = to;
      this.$router.push(to);
      this.$forceUpdate();
    },
    getDropClass(item) {
      return this.dropActive[item.name] ? "TSidebarNavDropdownActive" : "TSidebarNavDropdown";
    },
    getDropChild(item) {
      return this.dropActive[item.name] ? "TSidebarNavDropdownItemsActive" : "TSidebarNavDropdownItems";
    },
    dropText(item) {
      return this.dropActive[item.name] ? "dropTextActive" : "dropText";
    },
    getIClass(to) {
      return this.tabActive === to ? "TSidebarNavItemActive" : "TSidebarNavItem";
    },
    getAClass(to) {
      return this.tabActive === to ? "TSidebarNavDropdownItemsChildActive" : "TSidebarNavDropdownItemsChild";
    },
    getLineClass(to) {
      return this.tabActive === to ? "d-inline-block bg-primary" : "d-inline-block bg-dark";
    },
    handleOutsideClick(e) {
      if (window.innerWidth >= 992) return;
      const sidebar = this.$el;

      if (!sidebar.contains(e.target)) {
        this.$store.commit("set", ["sidebarShow", false]);
      }
    },
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  mounted() {
    // document.addEventListener("click", this.handleOutsideClick);
  },
};
</script>
<style lang="scss">
.c-sidebar {
  transition: transform 0.3s ease-in-out;
}

@media (max-width: 991px) {
  .c-sidebar:not(.c-sidebar-show) {
    transform: translateX(-100%);
  }
}

.c-sidebar-backdrop {
  display: none !important;
}
.custom-text {
  font-family: "Manrope", sans-serif;
  letter-spacing: 0.7px;
}

.c-sidebar-backdrop {
  pointer-events: none !important;
}

button svg {
  width: 24px;
  height: 24px;
}
// $sidebar-bg: blue;
:root {
  // --primary_matcha-custom-theme: #86b3a4;
  --primary_matcha-custom-theme: rgba(229, 231, 232, 1);
  --primary_orange-custom-theme: #f89d1d;
  --secondary_orange-custom-theme: #fae9cd;
  --primary_blue-custom-theme: rgba(1, 57, 180, 1);
  --primary_seamless-custom-theme: #f1f2f7;
  --default_black-custom-theme: #595959;
  --line-custom-theme: #c9cacd;
  --white-custom-theme: #fff;
  --serova-custom-theme: #0139b4;

  // --light-custom-theme: white;
  // --dark-custom-theme: black;
  // --warning-custom-theme: red;
}
.c-sidebar {
  // background-color: var(--serova-custom-theme);
  background-color: var(--white-custom-theme);
  padding: 5px;
  // gap: 10px;
  //  background-color: rgba(225, 225, 225, 0.6);

  .c-sidebar-brand {
    background-color: var(--white-custom-theme);
    color: var(--default_black-custom-theme);
  }

  .c-sidebar-nav {
    background-color: var(--white-custom-theme);
    margin-top: 2px;
    gap: 2.5px;
    .c-sidebar-nav-item {
      background-color: var(--white-custom-theme);
      border: solid 1px #595959;
      border-radius: 7px;
      &:hover {
        background-color: var(--primary_seamless-custom-theme);
      }

      .c-sidebar-nav-link {
        color: var(--default_black-custom-theme);
        // border-bottom: 1px solid var(--line-custom-theme);
        &:hover {
          color: var(--white-custom-theme);
          background-color: var(--primary_matcha-custom-theme);

          .c-sidebar-nav-icon {
            color: var(--white-custom-theme);
          }
        }
        // &:focus {
        //   color: var(--white-custom-theme);
        //   background-color: var(--primary_matcha-custom-theme);

        //   .c-sidebar-nav-icon {
        //     color: var(--white-custom-theme);
        //   }
        // }
        &.c-active {
          color: var(--white-custom-theme);
          background-color: var(--primary_matcha-custom-theme);

          .c-sidebar-nav-icon {
            color: var(--white-custom-theme);
          }
        }

        .c-sidebar-nav-icon {
          color: var(--default_black-custom-theme);
        }
      }
    }

    .c-sidebar-nav-dropdown-toggle {
      color: var(--default_black-custom-theme);
      border: solid 1px #595959;
      border-radius: 7px;
      &:hover {
        color: var(--white-custom-theme);
        background-color: var(--primary_matcha-custom-theme);

        .c-sidebar-nav-icon {
          color: var(--white-custom-theme);
        }
      }
      // &:focus {
      //   color: var(--white-custom-theme);
      //   background-color: var(--primary_matcha-custom-theme);

      //   .c-sidebar-nav-icon {
      //     color: var(--white-custom-theme);
      //   }
      // }
      //

      .c-sidebar-nav-icon {
        color: var(--default_black-custom-theme);
      }

      // .c-sidebar-nav-dropdown-toggle {
      //     &::after {
      // color: var(--default_black-custom-theme);
      // background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='%23000' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E");
      // }
      // }
    }
  }

  // .c-sidebar:hover{
  //     overflow-y: auto;
  //     overflow-x: auto;
  // }

  .ps {
    overflow: hidden !important;
    overflow-anchor: none;
    -ms-overflow-style: none;
    touch-action: auto;
    -ms-touch-action: auto;

    .ps__rail-x,
    .ps__rail-y {
      position: absolute;
      display: none;
      opacity: 0;
      -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
      transition: background-color 0.2s linear, opacity 0.2s linear;
    }

    .ps--focus > .ps__rail-x,
    .ps--focus > .ps__rail-y,
    .ps--scrolling-x > .ps__rail-x,
    .ps--scrolling-y > .ps__rail-y,
    .ps:hover > .ps__rail-x,
    .ps:hover > .ps__rail-y {
      opacity: 0.6;
    }
  }

  html:not([dir="rtl"]) .ps__rail-y {
    right: 0;
  }

  .c-sidebar.c-sidebar-fixed {
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 1030;
  }

  .logout {
    padding: 1rem 0.5rem;
    color: var(--default_black-custom-theme);
    &:hover {
      cursor: pointer;
      color: var(--white-custom-theme);
      background-color: var(--primary_matcha-custom-theme);

      .c-sidebar-nav-icon {
        color: var(--white-custom-theme);
      }
    }
    background-color: #ffff;
    cursor: pointer;
    position: relative;
  }
  // padding: 0.8445rem 1rem;
}

.cursor-pointer {
  cursor: pointer;
}

.TSidebarNavSeparator {
  min-height: 50px;
}

.TSidebarNavItem {
  border: 2px #595959 solid;
  color: #595959;
  border-radius: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  border-collapse: collapse;
  margin-top: 3px;
  cursor: pointer;
  .icon-menu-stroke {
    stroke: #595959;
  }
  .icon-menu-fill {
    fill: #595959;
  }
  &:hover {
    background-color: var(--primary_seamless-custom-theme);
    border: 2px blue solid;
    color: var(--primary_blue-custom-theme);
    .icon-menu-stroke {
      stroke: var(--primary_blue-custom-theme);
    }
    .icon-menu-fill {
      fill: var(--primary_blue-custom-theme);
    }
  }
}

.TSidebarNavItemActive {
  color: rgba(1, 57, 180, 1) !important;
  background-color: rgba(198, 223, 255, 0.26);
  border: 2px rgba(1, 57, 180, 1) solid;
  border-radius: 5px;
  border-radius: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-collapse: collapse;
  margin-top: 3px;
  cursor: pointer;
  .icon-menu-stroke {
    stroke: var(--primary_blue-custom-theme);
  }
  .icon-menu-fill {
    fill: var(--primary_blue-custom-theme);
  }
  &:hover {
    background-color: var(--primary_seamless-custom-theme);
    color: var(--primary_blue-custom-theme);
    .icon-menu-stroke {
      stroke: var(--primary_blue-custom-theme);
    }
    .icon-menu-fill {
      fill: var(--primary_blue-custom-theme);
    }
  }
}

.TSidebarNavDropdown {
  border: 2px #595959 solid;
  color: #595959;
  border-radius: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-collapse: collapse;
  margin-top: 3px;
  cursor: pointer;
  .icon-drop-stroke {
    stroke: #595959;
  }
  .icon-drop-fill {
    fill: #595959;
  }
  .icon-size {
    fill: #595959;
  }
  .icon-size-big {
    fill: #595959;
  }
  &:hover {
    background-color: var(--primary_seamless-custom-theme);
    border: 2px var(--primary_blue-custom-theme) solid;
    color: var(--primary_blue-custom-theme);
    .icon-drop-stroke {
      stroke: var(--primary_blue-custom-theme);
    }
    .icon-drop-fill {
      fill: var(--primary_blue-custom-theme);
    }
    .icon-size {
      fill: var(--primary_blue-custom-theme);
    }
    .icon-size-big {
      fill: var(--primary_blue-custom-theme);
    }
  }
}

.TSidebarNavDropdownActive {
  border: 2px rgba(1, 57, 180, 1) solid;
  color: rgba(1, 57, 180, 1);
  border-radius: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-collapse: collapse;
  margin-top: 2px;
  background-color: rgba(219, 225, 241, 1);
  cursor: pointer;
  .icon-drop-stroke {
    stroke: var(--primary_blue-custom-theme);
  }
  .icon-drop-fill {
    fill: var(--primary_blue-custom-theme);
  }
  .icon-size {
    fill: var(--primary_blue-custom-theme);
  }
  .icon-size-big {
    fill: var(--primary_blue-custom-theme);
  }
  &:hover {
    background-color: var(--primary_matcha-custom-theme) !important;
    color: (--primary_matcha-custom-theme) !important;
  }
}

.TSidebarNavDropdownItems {
  border: 2px #595959 solid;
  color: black;
  border-radius: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-collapse: collapse;
  margin-top: 2px;
  cursor: pointer;
  &:hover {
    background-color: var(--primary_seamless-custom-theme);
    color: var(--primary_blue-custom-theme);
  }
}

.TSidebarNavDropdownItemsActive {
  color: var(--white-custom-theme) !important;
  background-color: rgba(198, 223, 255, 0.26);
  padding-top: 2px;
  padding-bottom: 2px;
  border-collapse: collapse;
  margin-top: 2px;
  cursor: pointer;
  // &:hover {
  //   background-color: var(--primary_matcha-custom-theme);
  //   color: var(--white-custom-theme) !important;
  // }
}

.TSidebarNavDropdownItemsChild {
  border-collapse: collapse;
  margin-top: 2px;
  color: black;
  cursor: pointer;
  &:hover {
    background-color: rgba(229, 231, 232, 1) !important;
    color: black !important;
  }
}

.TSidebarNavDropdownItemsChildActive {
  color: rgba(1, 57, 180, 1) !important;
  background-color: rgba(219, 225, 241, 1);
  border-radius: 2px;
  margin-top: 2px;
  cursor: pointer;
  &:hover {
    background-color: var(--primary_matcha-custom-theme);
    color: var(--white-custom-theme);
  }
}

::-webkit-scrollbar {
  width: 1.5px;
  height: 1.5px;
}

::-webkit-scrollbar-thumb {
  background: transparent;
}

::-webkit-scrollbar-track {
  background: transparent;
}

ul {
  list-style-type: none;
}

.icon-menu-stroke {
  width: 20px;
  height: 26px;
}

.icon-menu-fill {
  width: 20px;
  height: 26px;
}

.icon-size {
  width: 10px;
  height: 16px;
}

.icon-size-big {
  width: 16px;
  height: 32px;
}
</style>
